/**
 * @file FooterScriptsSlot.tsx
 *
 * @fileoverview Prints custom scripts on the site footer.
 */

import React from 'react';
import { useFrontendConfig } from '~/jobiqo/context/frontendConfig';

// Bing script to count conversions for WorkplaceDiversity website only.
const BING_WPD_TRACKING_SCRIPT = `
  (function(w,d,t,r,u) {
    var f,n,i;
    w[u]=w[u]||[],f=function() {
      var o={ti:"343173388", enableAutoSpaTracking: true};
      o.q=w[u],w[u]=new UET(o),w[u].push("pageLoad")
    },
    n=d.createElement(t),n.src=r,n.async=1,n.onload=n.onreadystatechange=function() {
      var s=this.readyState;
      s&&s!=="loaded"&&s!=="complete"||(f(),n.onload=n.onreadystatechange=null)
    },
    i=d.getElementsByTagName(t)[0],i.parentNode.insertBefore(n,i)
  })(window,document,"script","//bat.bing.com/bat.js","uetq");
`;

export const FooterScriptsSlot = () => {
  const { frontend } = useFrontendConfig();
  switch (frontend) {
    case 'workplacediversity':
      return (
        <script
          dangerouslySetInnerHTML={{ __html: BING_WPD_TRACKING_SCRIPT }}
        />
      );

    default:
      return null;
  }
};
export default FooterScriptsSlot;
